<!--
 * @Author: Lemon C
 * @Date: 2024-05-10 11:27:10
 * @LastEditTime: 2025-03-13 11:39:14
-->
<template>
    <div class="sup-web-code">
        <div class="code-top">
            <div class="code-fold-btn" @click="eltree_fold_action">
                <el-icon v-if="!eltree_fold"><Fold /></el-icon>
                <el-icon v-if="eltree_fold"><Expand /></el-icon>
            </div>
            <div class="code-title">{{ tree_name }}</div>
            <div class="code-action-btn-group">
                <el-button id="id_btn_copy" class="code-action-btn" size="default" icon="CopyDocument" @click="code_copy">复制</el-button>
                <el-button class="code-action-btn" size="default" icon="RefreshRight" @click="code_refresh">重置</el-button>
                <el-button class="code-action-btn" size="default" icon="Refresh" @click="code_run">运行</el-button>
            </div>
        </div>
        <div class="code-content">
            <Codemirror
                class="my-codemirror"
                v-model="code_content"
                :extensions="[javascript()]"
                style="height: 100%; color: var(--color-main-text-primary); width: 100%"
                placeholder="Start typing your code..." />
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch, getCurrentInstance, nextTick } from 'vue';
import { Codemirror } from 'vue-codemirror';
import { javascript } from '@codemirror/lang-javascript';

import { getDemoByDocId } from '@/service/interface';

const { proxy } = getCurrentInstance();

const props = defineProps({
    comp_tree_node_id: String,
    comp_tree_node_name: String,
    code_comp_update_data: Function,
    code_comp_fold_callback: Function,
});

const tree_name = ref(''); //当前选中的demo标题
const eltree_fold = ref(false); //是否可以折叠目录树
const code_content = ref(''); //代码

watch(
    () => props.comp_tree_node_id,
    (val) => {
        service_get_demo_code();
    }
);

onMounted(() => {
    service_get_demo_code();
});

// MARK Service  获取demo文档
const service_get_demo_code = () => {
    tree_name.value = props.comp_tree_node_name || '';
    let params = {
        dcid: props.comp_tree_node_id,
    };
    proxy.$showLoading();
    getDemoByDocId({ params }).then((res) => {
        proxy.$hideLoading();
        if (res.isSuccess && res.data != '{}' && Object.keys(res.data).length > 0) {
            code_content.value = res.data.file;
            props.code_comp_update_data(res.data.file);
        } else {
            code_content.value = '';
            props.code_comp_update_data('');
        }
    });
};

// MARK Tree 目录折叠
const eltree_fold_action = () => {
    eltree_fold.value = !eltree_fold.value;
    props.code_comp_fold_callback(eltree_fold.value);
};

// MARK 复制代码
const code_copy = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(code_content.value);
            proxy.$message.success('复制成功');
        } catch (error) {
            console.error('使用 clipboard API 复制失败: ', error);
            proxy.$message.error('复制失败，请重试');
        }
    } else {
        // 创建一个隐藏的 textarea 元素，因为 textarea 可以更好地处理多行文本
        const textarea = document.createElement('textarea');
        textarea.value = code_content.value; // 设置文本值，包含回车符
        document.body.appendChild(textarea);
        // 触发复制操作
        textarea.focus();
        textarea.select();
        const result = document.execCommand('copy');
        // 移除 textarea 元素
        document.body.removeChild(textarea);
        // 检查复制结果并给出反馈
        if (!result || result === 'unsuccessful') {
            proxy.$message.warning('复制失败（剪贴板不存在）');
        } else {
            proxy.$message.success('复制成功');
        }
    }
};

// MARK 重置代码
const code_refresh = () => {
    service_get_demo_code();
};

// MARK 运行代码
const code_run = () => {
    props.code_comp_update_data(code_content.value);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-web-code {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .code-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--color-main-light-bg-white);
        height: 54px;

        .code-fold-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 30px;
            height: 32px;
            cursor: pointer;
            background: var(--color-main-brand);
            box-shadow: 0px 2px 4px 0px rgba(194, 194, 194, 0.5);
            border-radius: 4px;
            color: var(--color-main-text-brand-bg-primary);
            margin-left: 3px;
            flex-shrink: 0;
        }

        .code-title {
            color: var(--color-main-text-secondary);
            font-size: 20px;
            flex: 1;
            margin: 0 10px;
            min-width: 50px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .code-action-btn-group {
            display: flex;
            justify-content: space-between;
            padding: 10px;

            .code-action-btn {
                background: var(--color-main-brand);
                box-shadow: 0px 2px 4px 0px rgba(194, 194, 194, 0.5);
                border-radius: 4px;
                font-size: 14px;
                color: var(--color-main-text-brand-bg-primary);
            }
        }
    }

    :deep(.code-content) {
        height: calc(100% - 54px);
        width: 100%;
        background: var(--color-main-light-bg-white);

        .my-codemirror {
            width: 100%;
            overflow: hidden;
            background: var(--color-main-light-bg-white);
            font-size: 16px;
            line-height: 20px;
            .cm-content {
                flex-shrink: unset !important;
                white-space: pre-wrap !important;
            }
        }
    }
}
</style>
